import React from 'react'
import { ReactComponent as Line } from './line.svg'

const Separator: React.FC = () => <Line data-testid="separator" />

export default Separator
